import contacts from 'src/i18n/fr/fields/contacts';
import contact_groups from 'src/i18n/fr/fields/contact_groups';
import invoices from 'src/i18n/fr/fields/invoices';
import payments from 'src/i18n/fr/fields/payments';
import tax_receipts from 'src/i18n/fr/fields/tax_receipts';
import events from 'src/i18n/fr/fields/events';
import event_transactions from 'src/i18n/en/fields/fundraisingTransaction';

const fields = {
  contacts,
  contact_groups,
  events,
  event_transactions,
  invoices,
  payments,
  tax_receipts,
};

export default fields;
